import { render } from "./ReuseHuman.vue?vue&type=template&id=b6563ed8&scoped=true"
import script from "./ReuseHuman.vue?vue&type=script&lang=js"
export * from "./ReuseHuman.vue?vue&type=script&lang=js"

import "./ReuseHuman.vue?vue&type=style&index=0&id=b6563ed8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6563ed8"]])

export default __exports__